import { useState } from 'react';
import { api, ApiError } from '../../api';

// Masaüstü proqramı qoşmaq (KT-80): proqram açıq açarını göstərir → sahib burada yapışdırır → server cihazı «gözləyən»
// kimi qeyd edir → qoşulma kodu (şirkət:cihaz) proqrama yazılır → sonra aşağıda rol seçilib təsdiqlənir.
// Açıq açar sirr deyil; gizli açar kompüterdən çıxmır.
export function DeviceConnect({ tenantId, onRegistered }: { tenantId: string; onRegistered: () => void }) {
  const [open, setOpen] = useState(false);
  const [name, setName] = useState('');
  const [key, setKey] = useState('');
  const [code, setCode] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function register() {
    setBusy(true);
    setError(null);
    try {
      const d = await api.deviceRegister({ name: name.trim(), kind: 'desktop', platform: 'Windows', appVersion: null, publicKey: key.trim() });
      setCode(`${tenantId}:${d.id}`);
      setName('');
      setKey('');
      onRegistered();
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Cihaz əlavə olunmadı');
    } finally {
      setBusy(false);
    }
  }

  if (!open) {
    return (
      <button type="button" className="btn-small" onClick={() => setOpen(true)}>
        Masaüstü proqramı qoş
      </button>
    );
  }

  return (
    <div className="device-connect" role="group" aria-label="Masaüstü proqramı qoşmaq">
      <h3>Masaüstü proqramı qoşmaq</h3>
      <ol className="small">
        <li>Kompüterdə Kassa proqramını açın — «Cihaz açarı» görünəcək.</li>
        <li>Açarı aşağıya yapışdırın və cihaza ad verin (məs. «Kassa 1»).</li>
        <li>Çıxan qoşulma kodunu proqrama yazın, sonra burada rolu seçib təsdiqləyin.</li>
      </ol>
      <label className="field">
        Cihazın adı
        <input value={name} onChange={(e) => setName(e.target.value)} maxLength={80} disabled={busy} />
      </label>
      <label className="field">
        Cihaz açarı
        <input className="mono" value={key} onChange={(e) => setKey(e.target.value)} placeholder="44 simvol" maxLength={60} disabled={busy} />
      </label>
      {error && (
        <p className="bad" role="alert">
          {error}
        </p>
      )}
      <div className="toolbar">
        <button type="button" className="btn-primary" onClick={() => void register()} disabled={busy || !name.trim() || key.trim().length < 40}>
          Cihazı əlavə et
        </button>
        <button type="button" className="link-btn" onClick={() => (setOpen(false), setCode(null))}>
          Bağla
        </button>
      </div>
      {code && (
        <div className="lock-panel card" role="status" aria-label="Qoşulma kodu">
          <p className="ok">Cihaz əlavə olundu. Bu kodu proqrama yazın:</p>
          <p className="mono" style={{ userSelect: 'all', overflowWrap: 'anywhere' }}>
            {code}
          </p>
          <p className="muted small">Sonra aşağıda «Təsdiq gözləyən cihaz» bölməsində kassanı seçib təsdiqləyin.</p>
        </div>
      )}
    </div>
  );
}
